import { ajaxService, loadState, urlService } from "../services";
import { loadResource, Response } from "../utility";

const removeDependency = () => { ajaxService.removeDependency() }

export async function getBlogs(refresh = false) {
    removeDependency()
    if (refresh) {
        return await loadResource(urlService.blogs, 'blogs');
    } else {
        let blogs = await loadState('blogs');

        if (blogs == null) {
            return await loadResource(urlService.blogs, 'blogs');
        } else {
            return Response(blogs);
        }
    }
}

export async function getBlog(id) {
    removeDependency()
    let blogs = await loadState('blogs');
    if (blogs !== null) {
        return blogs.find(i => i.id == id);
    } else {
        return ajaxService.get(urlService.blogs + '/' + id).then(response => {
            return Response(response.data);
        })
    }
}


export async function saveBlog(data) {
    removeDependency()
    return ajaxService.post(urlService.blogs, data).then(response => {
        return Response(response.data);
    })
}

export async function updateBlog(id, data) {
    removeDependency()
    return ajaxService.put(urlService.blogs + '/' + id, data).then(response => {
        return Response(response.data);
    })
}

export async function deleteBlog(id) {
    removeDependency()
    return ajaxService.delete(urlService.blogs + '/' + id).then(response => {
        return Response(response.data);
    })
}